import { Form } from 'react-bootstrap';

function DonorListPayments({label, selectedPayments, payments, id, onClick }) {
   
    const isChecked = selectedPayments.includes(payments);
  
    return (
      <Form.Group controlId={id}>
      <Form.Check 
        type="checkbox" 
        label={label}
        checked={isChecked} 
        onChange={() => onClick(payments)} 
      />
    </Form.Group>
    );
  }
  
  export default DonorListPayments;
  